import styled from "@emotion/styled";
import { Text, WordBreak } from "atoms";
import { hexToRGB } from "styles/styleUtils";

import culture from "assets/images/roadmap_culture.svg";
import dao from "assets/images/roadmap_dao.svg";
import education from "assets/images/roadmap_education.svg";
import experiences from "assets/images/roadmap_experiences.svg";
import game from "assets/images/roadmap_game.svg";
import merch from "assets/images/roadmap_merch.svg";
import metaverse from "assets/images/roadmap_metaverse.svg";
import partners from "assets/images/roadmap_partners.svg";
import royalties from "assets/images/roadmap_royalties.svg";
import social from "assets/images/roadmap_social.svg";
import tokenomics from "assets/images/roadmap_tokenomics.svg";
import tools from "assets/images/roadmap_tools.svg";

const categoryImageMap = {
  // project: generativemasks
  "Merchandise/Physical Goods": merch,
  // project: generativemasks
  "Education/Resources": education,
  // project: generativemasks
  "Allowlists/Partnerships": partners,
  // project: generativemasks
  "Royalty Distribution": royalties,
  // project: generativemasks
  "Social Impact": social,
  // project: women-hackers-club
  "Tokenomics/Staking": tokenomics,
  // project: nouns
  DAO: dao,
  // project: deadfellaz
  "IRL Experiences": experiences,
  // project: deadfellaz
  Metaverse: metaverse,
  // Project: ruler-of-the-land
  "Game/P2E": game,
  // Project: ???
  "Platform and Tools": tools,
  "For The Culture": culture,
} as const;

type Category = keyof typeof categoryImageMap;

interface Props {
  categories: string[];
}

function RoadmapCategories({ categories }: Props) {
  return (
    <RoadmapContainer>
      {categories.map((category) => (
        <RoadmapCategory key={category}>
          <div>
            <img src={categoryImageMap[category as Category]} alt="" />
          </div>
          <Text size="xs">
            <WordBreak value={category} on="/" />
          </Text>
        </RoadmapCategory>
      ))}
    </RoadmapContainer>
  );
}

const width = "145px";

const RoadmapContainer = styled.ul({
  display: "grid",
  gap: "1rem",
  gridTemplateColumns: "repeat(2, calc(50% - .5rem))",
  justifyContent: "start",
  listStyleType: "none",
  margin: 0,
  padding: 0,
  "@media (min-width: 360px)": {
    gridTemplateColumns: `repeat(auto-fill, minmax(${width}, 1fr))`,
  },
});

const RoadmapCategory = styled.li(({ theme }) => ({
  alignItems: "center",
  // width,
  maxWidth: "100%",
  // height: width,
  background: hexToRGB(theme.colors.yellow, 0.3),
  borderRadius: theme.borderRadius.sm,
  display: "grid",
  gap: 10,
  gridTemplateRows: "56px 2rem",
  padding: "0.5rem 0.65rem",
  textAlign: "center",
  "& > div": {
    display: "flex",
    justifyContents: "center",
    alignItems: "center",
  },
  img: {
    margin: "0 auto",
    maxHeight: "75px",
  },
  p: {
    display: "inline-block",
    lineHeight: "1.2",
    margin: 0,
    fontSize: "14px",
  },
}));

export { RoadmapCategories };
